import { GERMAN_LOCALE } from './german';

const listFormatter = new Intl.ListFormat(GERMAN_LOCALE, {
  style: 'long',
  type: 'conjunction',
});

export const formatList = (items: number[] | string[]): string => listFormatter.format(items.map(String));
